import { PopupModal } from "components/modals/ModalBox";
import React from "react";
import useButtonLoader from "hooks/useButtonLoader";
import { deleteUserApi } from "services/user";
import { toastMessage } from "utils/toastMessage";

const DeleteSelectedUser = ({
  selectedUserDetail,
  onClose,
  setUserList,
  deleteModel,
}) => {
  const [buttonLoader, setButtonLoader] = useButtonLoader("Yes");
  // change delete handler
  const changeDeleteHandler = async () => {
    try {
      setButtonLoader(true);
      const { data: responseData, status } = await deleteUserApi({
        userId: selectedUserDetail._id,
      });
      if (status === 200) {
        // Remove the deleted user from the list
        setUserList((prevList) =>
          prevList.filter((user) => user._id !== selectedUserDetail._id)
        );
        onClose();
        toastMessage(responseData.message, "success", "deleteUser");
      }
    } catch (e) {
      console.log("error:", e.error);
    } finally {
      setButtonLoader(false);
    }
  };

  return (
    <>
      <PopupModal
        show={deleteModel}
        handleClose={onClose}
        content="Are you sure you want to Delete this user?"
        title="Delete User"
        buttonLoader={buttonLoader}
        action={changeDeleteHandler}
      />
    </>
  );
};

export default DeleteSelectedUser;
